import { inject, Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { renderMarkdown, MarkdownOptions } from '../util/markdown';

/**
 * Renders Markdown to sanitised HTML (Angular 16+ standalone pipe).
 */
@Pipe({ name: 'ragMarkdown', standalone: true })
export class RagMarkdownPipe implements PipeTransform {
  private readonly sanitizer = inject(DomSanitizer);

  transform(value: string | null | undefined, options?: MarkdownOptions): SafeHtml {
    const html = renderMarkdown(value, options ?? {});
    return html ? this.sanitizer.bypassSecurityTrustHtml(html) : '';
  }
}
